import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import {
  blackColor,
  blackShade19,
  blackShade21,
  blackShade22,
  greenColor02,
  whiteColor,
  yellowShade03,
} from "../../../configs/styles/muiThemes";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const SkuSyncSuccess = ({ productsAdded, onConfirm }) => {

  return (
    <Box p="15px 0 0">
      <Grid container>
        <Grid item xs={12} md={7}>
          <Box sx={styles.card}>
            <CheckCircleIcon sx={{ fontSize: "50px", color: greenColor02 }} />

            <Typography
              fontSize={16}
              fontWeight={600}
              my="10px"
              color={blackShade22}
            >
              {productsAdded
                ? productsAdded?.length > 1
                  ? `${productsAdded?.length} SKUs `
                  : `${productsAdded?.length} SKU `
                : ""}{" "}
              Synced Successfully
            </Typography>

            <Typography
              fontSize={13}
              fontWeight={400}
              color={blackShade21}
              textAlign="center"
              mb={2}
            >
              SKUs Sync Successfully. The synced products will appear in the
              Catalog New Products {`>>`} Pending Approval tab, and you may need
              to provide additional detail required by our system to process
              your orders.
            </Typography>

            <Button
              variant="contained"
              sx={styles.nextBtn}
              disableElevation
              onClick={onConfirm}
            >
              DONE
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SkuSyncSuccess;

const styles = {
  heading: {
    fontSize: "14px",
    fontWeight: "600",
    color: blackShade19,
    mb: 1,
  },

  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ${greenColor02}`,
    borderRadius: "10px",
    padding: "20px",
  },

  nextBtn: {
    fontSize: 13,
    fontWeight: 500,
    color: blackColor,
    backgroundColor: yellowShade03,
    border: `1px solid ${yellowShade03}`,
    padding: "7px 30px",
    borderRadius: "7px",
    "&:hover": {
      color: yellowShade03,
      backgroundColor: whiteColor,
    },
  },
};
